import * as joint from 'jointjs';
import { BaseElement } from '../../../../../../api/com/MetaPattern/MDA/MD/Base/BaseElement';
import { EventBus } from '../../../Product/IDE/Util/EventBus';
import { MDExtendService } from '../../MD/MDExtendService';
import { MDBaseShape } from './MDBaseShape';
import { ShapeModel } from './ShapeModel';

/**
 * 带有子元素列表的图形
 * 1、TODO：目前只支持选中一行，不支持多行
 */
export abstract class PartShape extends MDBaseShape {
  /** 重写超类属性 */
  defaults() {
    return {
      ...super.defaults,
      // 定义图形的实际类型
      type: 'mst.PartShape',
      attrs: {
        rect: { 'stroke-width': 0, fill: '#FFFFFF' },
        '.uml-class-container': { fill: '#e2e7f5', strokeWidth: 2, stroke: '#e2e7f5', event: 'type:link', cursor: 'move' },
        '.uml-class-part-rect': { fill: '#e2e7f5', height: 2 },
        '.uml-class-row-rect': { fill: '#ffffff', height: 20, style: 'cursor:default', event: 'class:row:select' },
        '.uml-class-row-rect-selected': { fill: 'Blue', height: 20, style: 'cursor:default', event: 'class:row:select' },
        '.uml-collapse-rect': { width: 15, height: 15, stroke: '#545c64', strokeWidth: 1, style: 'cursor:hand', event: 'class:collapse' },
        '.uml-collapse-text': { fontSize: 18, fill: '#545c64', style: 'cursor:hand', event: 'class:collapse' },
        '.uml-type-icon': { width: 15, height: 15, strokeWidth: 0, fill: '#000000' },

        '.uml-class-name-text': {
          ref: '.uml-class-container',
          'ref-y': 13,
          'ref-x': 0.5,
          'text-anchor': 'middle',
          'y-alignment': 'middle',
          'font-weight': 'bold',
          fill: 'black',
          'font-size': 12,
          event: 'type:link',
          cursor: 'move'
        },
        '.uml-class-row-text': { event: 'class:row:select', fontSize: 10, style: 'color:black;cursor:default;text-align:left;overflow:hidden;text-overflow:ellipsis;white-space:nowrap;height:20px;line-height:20px;' },
        '.uml-class-row-text-selected': { event: 'class:row:select', fontSize: 10, style: 'color:white;cursor:default;text-align:left;overflow:hidden;text-overflow:ellipsis;white-space:nowrap;height:20px;line-height:20px;' }
      },
      markup: '',
      maxHeight: 0,
      isCollapse: false,
      curRowDesignId: '',
      t_row_rect: '<rect class="uml-class-row-rect{selected}" transform="translate(0, {offsetY})" designId="{designId}" index="{index}" isLast="{isLast}"></rect>',
      t_row_text: '<foreignObject class="uml-class-row-text{selected}" transform="translate(5, {offsetY})" width="{width}" designId="{designId}" index="{index}" isLast="{isLast}">{text}<title>{text}</title></foreignObject>',
      t_part_rect: '<rect class="uml-class-part-rect" transform="translate(0, {offsetY})"/>'
    };
  }

  constructor(attributes?: any, opt?: any) {
    // 调用超类的构造器
    super(attributes, opt);
    // 重写图形，如果放在defaults上面会覆盖超类，这里只会修改不一致的项，Very Important
    this.attr({
      body: { fill: '#ffffc0', stroke: '#545c64' },
      label: {
        fill: '#000000',
        fontSize: 12
      }
    });

    this.initialize();
  }

  initialize() {
    // model发生变化的时候，无法捕捉到变化
    this.on(
      'change:model change:curRowDesignId',
      () => {
        this.updateRectangles();
        this.trigger('uml-update');
      },
      this
    );

    this.updateRectangles();
    joint.shapes.basic.Generic.prototype.initialize.apply(this, [this.attributes]);
  }

  /** 执行菜单命令 */
  public doAction(action: string, designId?: string): BaseElement | null {
    let element = super.doAction(action, designId);
    switch (action) {
      // 移到顶部
      case 'row:moveTop':
        element = this.moveTop(designId);
        break;
      // 往上移
      case 'row:moveUp':
        element = this.moveUp(designId);
        break;
      // 往下移
      case 'row:moveNext':
        element = this.moveNext(designId);
        break;
      // 移到底部
      case 'row:moveBottom':
        element = this.moveBottom(designId);
        break;
      default:
        break;
    }
    EventBus.$emit('pgValueChanged', element?.name, element?.sequence, designId);
    return element;
  }

  /** 获取图形选中的样式后缀 */
  private selectedFlag(designId: string): string {
    if (this.get('curRowDesignId') === designId) {
      return '-selected';
    }
    return '';
  }

  /** 输出图形的代码 */
  protected updateRectangles(setWidth?: number, setHeight?: number) {
    const t_part_rect = this.get('t_part_rect');
    const t_row_rect = this.get('t_row_rect');
    const t_row_text = this.get('t_row_text');
    const lineHeight = 20;

    const rects: Array<string> = new Array<string>();
    const texts: Array<string> = new Array<string>();
    const model = this.get('model') as ShapeModel;
    if (model == null) {
      return;
    }

    let width = this.size().width;
    if (setWidth) {
      width = setWidth;
    } else if (width === 0) {
      width = 180;
    }
    // let height = this.size().height;
    // if (setHeight) {
    //   height = setHeight;
    // }

    let offsetY = 25;
    let rowCount = 0;
    let isLast = false;
    let index = 1; // 行在Compartment中的顺序
    if (model.compartments.length > 0) {
      model.compartments.forEach((compartment: any) => {
        index = 1;
        rects.push(t_part_rect.replace('{offsetY}', offsetY));
        offsetY += 4;
        if (compartment.length > 0) {
          rowCount = compartment.length;
          compartment.forEach((element: BaseElement) => {
            isLast = false;
            if (index === rowCount) {
              isLast = true;
            }
            rects.push(
              t_row_rect
                .replace('{offsetY}', `${offsetY}`)
                .replace('{designId}', element.designId)
                .replace('{selected}', this.selectedFlag(element.designId))
                .replace('{index}', index.toString())
                .replace('{isLast}', isLast ? 'true' : 'false')
            );
            texts.push(
              t_row_text
                .replaceAll('{text}', this.getDisplayTitle(element))
                .replace('{offsetY}', offsetY)
                .replace('{designId}', element.designId)
                .replace('{selected}', this.selectedFlag(element.designId))
                .replace('{index}', index.toString())
                .replace('{isLast}', isLast ? 'true' : 'false')
                .replace('{width}', width - 5)
            );
            offsetY += lineHeight;
            index++;
          });
        }
      });
    }

    const height = offsetY + 5; // PartShape的高度自动控制，不能修改
    this.get('attrs').rect.width = width;

    this.set('maxHeight', height);
    const markup: Array<string> = new Array<string>();
    markup.push('<g>');
    markup.push(`<rect class="uml-class-container" rx="5" ry="5" width="${width}" height="${height}"/>`);
    markup.push('<image class="uml-type-icon" transform="translate(5, 5)"/>');
    markup.push(`<rect class="uml-collapse-rect" transform="translate(${width - 20}, 5)"/>`);
    if (!model.isCollapse) {
      markup.push(rects.join(''));
    }
    markup.push(`<text class="uml-class-name-text">${this.getDisplayTitle(model.element)}</text>`);
    markup.push('<text class="uml-collapse-text"><tspan>_</tspan></text>');
    // markup.push(`<div style="display:none">${model.element.description}</div>`);
    if (!model.isCollapse) {
      markup.push(texts.join(''));
    }
    markup.push('</g>');
    this.set('markup', markup.join(''));
    if (this.get('model').isCollapse) {
      this.get('attrs')['.uml-class-row-text'].visibility = 'hidden';
      this.get('attrs')['.uml-class-row-text-selected'].visibility = 'hidden';
      this.get('attrs')['.uml-class-row-rect'].visibility = 'hidden';
      this.get('attrs')['.uml-class-row-rect-selected'].visibility = 'hidden';
      this.get('attrs')['.uml-class-part-rect'].visibility = 'hidden';
      this.get('attrs')['.uml-class-container'].height = 30;
      this.get('attrs')['.uml-collapse-text'].text = '+';
      this.get('attrs')['.uml-collapse-text'].transform = `translate(${width - 18}, 4)`;
    } else {
      this.get('attrs')['.uml-class-row-text'].visibility = 'visible';
      this.get('attrs')['.uml-class-row-text-selected'].visibility = 'visible';
      this.get('attrs')['.uml-class-row-rect'].visibility = 'visible';
      this.get('attrs')['.uml-class-row-rect-selected'].visibility = 'visible';
      this.get('attrs')['.uml-class-part-rect'].visibility = 'visible';
      this.get('attrs')['.uml-class-container'].height = this.get('maxHeight');
      this.get('attrs')['.uml-collapse-text'].text = '_';
      this.get('attrs')['.uml-collapse-text'].transform = `translate(${width - 18}, -5)`;
    }
    this.size(width, height);
    this.trigger('uml-update');
  }

  private moveBottom(designId: string): BaseElement | null {
    for (let i = 0; i < this.model().compartments.length; i++) {
      const index = this.model().compartments[i].findIndex(element => element.designId === designId);
      if (index > -1) {
        const elements = this.model().compartments[i].splice(index, 1);
        this.model().compartments[i].push(...elements);
        MDExtendService.setElementListSequence(this.model().compartments[i], true);
        return elements[0];
      }
    }
    return null;
  }

  private moveTop(designId: string): BaseElement | null {
    for (let i = 0; i < this.model().compartments.length; i++) {
      const index = this.model().compartments[i].findIndex(element => element.designId === designId);
      if (index > -1) {
        const elements = this.model().compartments[i].splice(index, 1);
        this.model().compartments[i].unshift(...elements);
        MDExtendService.setElementListSequence(this.model().compartments[i], true);
        return elements[0];
      }
    }
    return null;
  }

  private moveUp(designId: string): BaseElement | null {
    for (let i = 0; i < this.model().compartments.length; i++) {
      const index = this.model().compartments[i].findIndex(element => element.designId === designId);
      if (index > 0) {
        const elements = this.model().compartments[i].splice(index, 1);
        this.model().compartments[i].splice(index - 1, 0, ...elements);
        MDExtendService.setElementListSequence(this.model().compartments[i], true);
        return elements[0];
      }
    }
    return null;
  }

  private moveNext(designId: string): BaseElement | null {
    for (let i = 0; i < this.model().compartments.length; i++) {
      const index = this.model().compartments[i].findIndex(element => element.designId === designId);
      if (index > -1) {
        const elements = this.model().compartments[i].splice(index, 1);
        this.model().compartments[i].splice(index + 1, 0, ...elements);
        MDExtendService.setElementListSequence(this.model().compartments[i], true);
        return elements[0];
      }
    }
    return null;
  }
}
